import {Location} from '@angular/common';
import {Injector} from '@angular/core';
import {LanguageService} from '@core/services/language.service';
import {SUPPORTED_LANGUAGES} from '@core/constants/languages';
import {Language} from '@tisa-group/models';
export function detectLanguageInitializerFactory(injector: Injector) {
  return () => {
    const location = injector.get(Location);
    const languageService = injector.get(LanguageService);

    const path = location.path(); // e.g., '/en/home'
    const pathSegments = path.split('/').filter(segment => segment); // Split & remove empty parts

    if (
      pathSegments.length > 0 &&
      SUPPORTED_LANGUAGES.includes(pathSegments[0] as Language)
    ) {
      return languageService.setLanguage(pathSegments[0] as Language); // Set language
    }

    return;
  };
}
